import { ButtonBase, Typography, styled } from "@mui/material";

import { useNavigate } from "react-router-dom";

function WalletCard({ item }) {
  const navigate = useNavigate();

  const handleClick = () => {
    const isBasket = item?.isHaveBasket;

    if (isBasket)
      navigate(`/wallet/basket/${item?.basketId}/${item?.portfolioId}`);
    else navigate(`/wallet/portfolio/${item?.portfolioId}`);
  };

  return (
    <Wallet onClick={() => handleClick()}>
      <Typography
        color={"text.main"}
        variant="subtitle1"
        textAlign={"right"}
        dir={"rtl"}
      >
        {item?.name}
      </Typography>
    </Wallet>
  );
}

const Wallet = styled(ButtonBase)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  position: "relative",
  borderRadius: "20px",
  padding: theme.spacing(2),
  minHeight: "100px",
  width: "100%",
}));

export default WalletCard;
